import './translations';
let initialized = false;
export default function initialize() {
    if (initialized) {
        throw new Error('auth already initialized');
    }
    initialized = true;
    // ...
}
